export default function ApprovalEditTemplate(data) {
//language=HTML
    return `
        <div id="window${data.elementId}" class="windowAccept">
            <div class="n-text-right py-2">
                <p>${data.translateId("summary")}</p>
                <p>${data.approvalCase.summary || "&nbsp"}</p>

                <div>
                    <div class="form-group">
                        <label for="nameCurrentStep">${data.translateId("nextStepName")}</label>
                        <input id="nameCurrentStep" class=" form-control w-100 py-0" type="text">
                    </div>
                    <div class="form-group">
                        <label for="numberCurrentStep">${data.translateId("nextStepSequence")}</label>
                        <input id="numberCurrentStep" class=" form-control w-100 py-0" type="number">
                    </div>
                    <div class="form-group">
                        <label>${data.translateId("decision")}</label>
                        <input class=" w-100 combobox-decision" id="${data.elementId}decisionCombo">
                    </div>
                    <div class="form-group">
                        <label>${data.translateId("escalateTo")}</label>
                        <div class=" w-100" id="escalateToRef"></div>
                    </div>
                    <div class="form-group">
                        <label>${data.translateId("approvalReason")}</label>
                        <div class=" w-100" id="appReasonRef">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="notes">${data.translateId("remarks")}</label>
                        <textarea id="notes" class=" form-control w-100" id="${data.elementId}remarksInput"></textarea>
                    </div>
                </div>
            </div>
            <div class="n-text-left mt-2">
                <button class=" k-button rounded-sm px-3" id="${data.elementId}okBtn">${data.translateId("ok")}</button>
                <button class=" k-button rounded-sm" id="${data.elementId}cancelBtn">${data.translateId("cancel")}</button>
            </div>
        </div>`;
}